import styles from './styles.less';

import Panel from './panel';
import UserViewVar from './view.constant';
import AddToAccount from './addToAccount';




// Module
import routes from './routes';

export default angular.module('app.main.panels.module',
	[
		Panel,
		AddToAccount,
	])
	.config(routes)
	.name



/** WEBPACK FOOTER **
 ** ./src/main/panels/index.js
 **/